module.exports = __webpack_public_path__ + "static/media/Galdisa_Ficha_Cacahuate_holandés.f74e581e.pdf";